import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=29bc8a7e&scoped=true&"
import script from "./Configurator.vue?vue&type=script&lang=ts&"
export * from "./Configurator.vue?vue&type=script&lang=ts&"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=29bc8a7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc8a7e",
  null
  
)

export default component.exports